import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { ShareModule } from '@iq-central-front-end/share';



@NgModule({
  declarations: [NotificationComponent],
  imports: [
    CommonModule,
    ShareModule
  ],
  exports: [NotificationComponent]
})
export class NotificationModule { }
